import { types } from "../constants/admintype";


export const getEmployeeData = (data) => ({
    type: types.GET_EMPLOYEEDATA_REQUEST,
    payload:data
});

export const getEmployeeAttendanceData = (data) => ({
  type: types.GET_EMPLOYEE_ATTENDANCE_REQUEST,
  payload:data
});


export const getEmployeeLeaveWfhRequestData = (data) => ({
  type: types.GET_EMPLOYEE_LEAVE_WFH_REQUEST,
  payload:data
});
// export const getWfhData = (data) => ({
//   type: types.GET_WFH_REQUEST,
//   payload:data
// });


export const getAssetsData = (data) => ({
  type: types.GET_ASSETS_REQUEST,
  payload:data
});
export const getDepartmentData = (data) => ({
  type: types.GET_DEPARTMENT_REQUEST,
  payload:data
});
export const getManagerData = (data) => ({
  type: types.GET_REPORTING_MANAGER_REQUEST,
  payload:data
});

export const getShiftData = (data) => ({
  type: types.GET_SHIFT_REQUEST,
  payload:data
});

export const getLeaveData = (data) => ({
  type: types.GET_LEAVE_REQUEST,
  payload:data
});

export const getWFHData = (data) => ({
  type: types.GET_WFH_REQUEST,
  payload:data
});
export const getBranchesData = (data) => ({
  type: types.GET_BRANCHES_REQUEST,
  payload:data
});
export const getAdminTicketData = (data) => ({
  type: types.GET_ADMINTICKET_REQUEST,
  payload:data
});


